export default __webpack_public_path__ + "static/media/arrow-up.a9b36792.svg";